import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { AnimatePresence, motion } from "framer-motion";
import { isEmpty } from "lodash";
const Notifications = () => {
  const { t } = useTranslation();
  const [messagelist, setMessageList] = useState([]);
  const message = async () => {
    const { status, data: response_users } = await apiGet(apiPath.messageList);
    if (response_users.success) {
      setMessageList(response_users?.results);
    }
  };
  const setAnnouncement = useContextSelector(AuthContext, (ctx) => {
    return ctx.setAnnouncement;
  });  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const announcement = useContextSelector(AuthContext, (ctx) => {
    return ctx.announcement;
  });
  useEffect(() => {
    if (!isEmpty(user)) {
      message();
    }
  }, [user]);
  const variants = {
    hidden: { y: 750 }, // start from bottom
    visible: { y: 0 }, // slide up into place
    exit: { y: 750 }, // slide up and out (top to bottom)
  };
  return (
    <>
      <div
        data-v-d56e9d5a
        className={`s-modal-mask s-fixed s-top-0 s-left-0 s-bottom-0 s-bg-black/50 s-backdrop-blur-[2px] s-w-full`}
        style={{
          display: announcement ? "block" : "none",
          "-622e6b4e": "300",
          "-302f011b": isMobile ? "100%" : "100% - 60px",
          "-183a105a": isMobile ? "100vh - 3rem" : "100vh - 60px - 11.2rem",
        }}
      />
      <div
        data-v-d56e9d5a
        className={`s-modal-container s-fixed s-bottom-0 s-flex-col s-bg-pop-title-bg s-text-global-font-default-light dark:s-text-global-font-default-dark s-px-3px s-rounded-t-5px ${
          isMobile ? "s-w-full s-full-screen" : "s-w-desktop s-full-screen"
        }`}
        style={{
          "--622e6b4e": "300",
          "--302f011b": isMobile ? "100%" : "100% - 60px",
          "--183a105a": isMobile ? "100vh - 3rem" : "100vh - 60px - 11.2rem",
        }}
      >
        <AnimatePresence mode="wait">
          {announcement && (
            <motion.div
              data-v-e15c02a7
              initial="hidden"
              animate="visible"
              exit="exit"
              variants={variants}
              transition={{ duration: 0.4, ease: "easeInOut" }}
            >
              <div
                data-v-d56e9d5a
                className="s-relative s-modal-title s-py-4 s-bg-pop-title-bg"
              >
                <h4
                  data-v-d56e9d5a
                  className="s-mb-0 s-font-bold s-text-17px s-text-center s-text-pop-title-text"
                >
                  {t("Notifications")}
                </h4>
                <span
                  onClick={() => setAnnouncement(false)}
                  data-v-d56e9d5a
                  className="s-icon-close s-absolute s-right-4 s-top-1/2 -s-translate-y-1/2 s-text-pop-title-text s-text-base"
                />
              </div>
              <div data-v-d56e9d5a>
                <div
                  data-v-d56e9d5a
                  className="s-modal-content s-px-24px s-pt-14px s-leading-6 s-rounded-t-3px s-bg-betSlip-light dark:s-bg-black-800 s-overflow-y-scroll s-full-screen"
                >
                  {messagelist?.length > 0 ? (
                    messagelist?.map((res) => {
                      return (
                        <div
                          data-v-654d7ea6
                          className="s-border-black-300 dark:s-border-secondary s-py-7px s-border-b"
                        >
                          <div
                            data-v-654d7ea6
                            className="s-mb-7px s-flex s-items-center"
                          ></div>
                          <p
                            data-v-654d7ea6
                            className="s-title s-text-14px s-font-bold s-break-words"
                          >
                            {res?.message}
                          </p>
                        </div>
                      );
                    })
                  ) : (
                    <div
                      data-v-654d7ea6
                      className="s-border-black-300 dark:s-border-secondary s-py-7px s-border-b"
                    >
                      <div
                        data-v-654d7ea6
                        className="s-mb-7px s-flex s-items-center"
                      ></div>
                      <p
                        data-v-654d7ea6
                        className="s-title s-text-14px s-font-bold s-break-words"
                      >
                        Welcome to bajifair.live
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default Notifications;
